import { DiscoveryPage as SharedDiscoveryPage } from '@trinetra/shared';
import { useNode } from '../contexts/NodeContext';
import CameraFormModal from '../components/modals/CameraFormModal';

function prefill(c: any) {
  const urls: string[] = Array.isArray(c.rtsp_urls) ? c.rtsp_urls : [];
  return {
    name: `camera-${c.ip_address}`,
    rtsp_url: urls[0] || '',
    sub_stream_rtsp_url: urls[1] || '',
    ip_address: c.ip_address || '',
    manufacturer: c.manufacturer || '',
    model: c.model || '',
  };
}

/** Cloud discovery: node-scoped (polling), gated on `discovery.view` — the same
 * permission the cloud BE proxy routes (scan/results/bulk-approve) authorize. */
export default function DiscoveryPage() {
  const { selectedNode } = useNode();
  return (
    <SharedDiscoveryPage
      requireNode
      nodeKey={selectedNode?.nodeId ?? null}
      discoverPermission="discovery.view"
      renderAddModal={(cam, { onClose, onAdded }) => (
        <CameraFormModal
          isOpen
          onClose={onClose}
          onSuccess={() => onAdded(cam.ip_address)}
          nodeId={selectedNode?.nodeId || ''}
          groups={[]}
          prefill={prefill(cam)}
        />
      )}
    />
  );
}
